// extracted by mini-css-extract-plugin
export default {"overlay":"HeroSection_overlay__5uhjA","content":"HeroSection_content__p+8di"};